export default __webpack_public_path__ + "static/4-2d8771b200b9ec0c137478b2ce77e63c.svg";